<div class="auth-page auth-page--split">
  <section class="auth-visual">
    <div class="auth-visual-inner">
      <a routerLink="/" class="auth-brand auth-brand--on-dark">
        <img src="logo.svg" alt="Every Rupee Spent logo" width="32" height="32" />
        <span>Every Rupee Spent</span>
      </a>
      <h1 class="auth-visual-title">Track every rupee. Stress less about money.</h1>
      <p class="auth-visual-subtitle">
        One place for budgets, bill reminders, rental management, and more — built for how India
        actually manages money.
      </p>
      <ul class="auth-visual-features">
        <li><mat-icon>check_circle</mat-icon><span>Log every expense free, unlimited — upgrade anytime for more budgets &amp; history</span></li>
        <li><mat-icon>check_circle</mat-icon><span>Bill, EMI &amp; renewal reminders — free to start</span></li>
        <li><mat-icon>check_circle</mat-icon><span>Your data stays private — HTTPS-secured, never sold</span></li>
      </ul>
    </div>
  </section>

  <section class="auth-form-panel">
    <div class="auth-wrapper">
      <div class="auth-brand auth-brand--mobile">
        <img src="logo.svg" alt="Every Rupee Spent logo" width="28" height="28" />
        <span>Every Rupee Spent</span>
      </div>
      <mat-card class="auth-card">
        <mat-card-header>
          <mat-card-title>Welcome back</mat-card-title>
          <mat-card-subtitle class="auth-card-subtitle">Log in to continue to your dashboard</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          @if (passwordResetSuccess()) {
            <p class="success-message">Your password has been reset. Log in with your new password.</p>
          }
          @if (passwordChangedSuccess()) {
            <p class="success-message">Your password has been changed. Log in with your new password.</p>
          }
          <form [formGroup]="form" (ngSubmit)="submit()">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" autocomplete="email" />
              @if (form.controls.email.hasError('required')) {
                <mat-error>Email is required</mat-error>
              } @else if (form.controls.email.hasError('email')) {
                <mat-error>Enter a valid email address</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Password</mat-label>
              <input matInput type="password" formControlName="password" autocomplete="current-password" />
              @if (form.controls.password.invalid) {
                <mat-error>Password is required</mat-error>
              }
            </mat-form-field>

            <a routerLink="/forgot-password" class="forgot-password-link">Forgot password?</a>

            @if (errorMessage(); as msg) {
              <p class="error-message">{{ msg }}</p>
            }

            <button mat-flat-button color="primary" type="submit" class="full-width" [disabled]="loading()">
              @if (loading()) {
                <mat-spinner diameter="20" />
              } @else {
                Log in
              }
            </button>
          </form>
        </mat-card-content>
        <mat-card-footer class="auth-footer">
          <a routerLink="/register">Need an account? <strong>Register</strong></a>
        </mat-card-footer>
      </mat-card>
      <footer class="page-footer">© {{ currentYear }} everyrupeespent.com</footer>
    </div>
  </section>
</div>
